import { useEffect, useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import styles from './Auth.module.css'

export default function ConfirmEmailChange() {
  const [params] = useSearchParams()
  const token = params.get('token') ?? ''

  const [status, setStatus] = useState<'loading' | 'ok' | 'error'>('loading')
  const [message, setMessage] = useState('')

  useEffect(() => {
    if (!token) {
      setStatus('error')
      setMessage('Dieser Bestätigungslink ist ungültig.')
      return
    }

    fetch(`/api/auth/verify-email-change?token=${encodeURIComponent(token)}`)
      .then(async (res) => {
        const data = (await res.json()) as { ok?: boolean; message?: string; error?: string }
        if (res.ok) {
          setStatus('ok')
          setMessage(data.message ?? 'E-Mail-Adresse erfolgreich geändert.')
        } else {
          setStatus('error')
          setMessage(data.error ?? 'Bestätigung fehlgeschlagen.')
        }
      })
      .catch(() => {
        setStatus('error')
        setMessage('Verbindungsfehler. Bitte erneut versuchen.')
      })
  }, [token])

  return (
    <div className={styles.card}>
      <h1 className={styles.heading}>E-Mail-Adresse bestätigen</h1>
      {status === 'loading' && <p className={styles.success}>Wird bestätigt…</p>}
      {status === 'ok' && (
        <>
          <p className={styles.success}>{message}</p>
          <div className={styles.footer}>
            <Link to="/settings" className={styles.link}>Zurück zu Einstellungen</Link>
          </div>
        </>
      )}
      {status === 'error' && (
        <>
          <p className={styles.error}>{message}</p>
          <div className={styles.footer}>
            <Link to="/settings" className={styles.link}>Zurück zu Einstellungen</Link>
          </div>
        </>
      )}
    </div>
  )
}
